var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetmeeWatermark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "getmee-watermark",
    transform: "translate(-110.254 -333.227)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M110.254,345.227a12,12,0,1,1,12,12A12,12,0,0,1,110.254,345.227Z",
    transform: "translate(0 0)",
    fill: "#038389",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(115.704 337.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M145.261,360.445l.387,0H149.9l.065,0c.044,0,.088,0,.131,0a2.432,2.432,0,0,0,2.3-2.428v0h-7.335v0a5.727,5.727,0,1,0,5.564,3.707h-2.757a3.294,3.294,0,1,1-2.6-1.279Z",
    transform: "translate(-139.534 -358.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M146.285,422.684a3.3,3.3,0,0,1-2.835-1.618h-2.641a5.727,5.727,0,0,0,10.953,0h-2.641A3.3,3.3,0,0,1,146.285,422.684Z",
    transform: "translate(-140.558 -408.642)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetmeeWatermark);
export default __webpack_public_path__ + "static/media/getmee-watermark.347575fb4c9e2edd1f456fe22f5700e2.svg";
export { ForwardRef as ReactComponent };